import React from "react";

const SuccessTick: React.FC<{ size?: number }> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64">
    <rect width="64" height="64" rx="16" fill="none" />
    <path
      d="M16 34L28 46L48 18"
      stroke="#1AB977"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default SuccessTick;
